(function () {
    'use strict';

    angular.module('app.charts')
        .directive('donutChart', donutChart);

    /* @ngInject */
    function donutChart(SETTINGS, $filter, DataFactory, Charts) {
        return {
            restrict: 'E',
            template: '<div class="chart-header"><div><h3 class="chart-title">{{chartTitle}}<span class="sub">{{subtitle}}</span></h3></div><i class="icon-cloud-download" ng-click="exportChart()" title="Download chart"></i><i class="icon-doc" ng-if="chartDataKey" ng-click="downloadData()" title="Download data"></i></div><div ng-if="!noData" class="cl-chart cl-chart-donut" id="{{id}}_chart"></div><div ng-if="noData" class="chart-no-data">{{noDataMessage}}</div><p ng-if="source && !noData" class="source">Source: {{source}}â€‹</p>',
            scope: {
                id: '@',
                chartData: '=',
                chartDataKey: '@',
                chartTitle: '@',
                subtitle: '@',
                source: '@',
                text: '@',
                colors: '=',
                precision: '=',
                theme: '@',
                legendLabelWidth: '=',
                legendColor: '@',
                innerRadius: '@',
                noDataMessage: '@',
                exportLabel: '=' // text to add to exported images
            },
            link: link
        };

        function link(scope, elm, attrs) {

            var chart,
                hiddenChart,
                hiddenID = scope.id + '_hidden',
                exportW = 800,
                exportH = 600,
                colors = SETTINGS.CHARTS.PALETTE,
                labelColors = ['#ffffff'],
                legendColor = '#000000',
                legendPosition = 'right',
                legendAlign = 'left',
                precision = SETTINGS.CHARTS.PRECISION;

            if (scope.id === undefined) {
                console.log('id must be set')
            }

            if (angular.isDefined(scope.colors)) {
                colors = scope.colors.split(',');
            }

            if (angular.isDefined(scope.legendColor)) {
                legendColor = scope.legendColor;
            }

            if (angular.isDefined(scope.precision)) {
                precision = parseInt(scope.precision, 10);
                // If unit becomes and optional argument
                // if (angular.isDefined(scope.unit) && scope.unit === "$") {
                //     precision = SETTINGS.CHARTS.DOLLARPRECISION;
                // }
            }

            if (!angular.isDefined(scope.noDataMessage)) {
                scope.noDataMessage = 'Data not available for this chart';
            }

            elm.append('<div class="chart-hidden" id="' + hiddenID + '"></div>');

            scope.$watch('chartData', function (newVal) {
                if (angular.isArray(newVal) && newVal.length > 0) {

                    // Inspect the first data point to see if we have data
                    if (Charts.hasData(newVal)) {
                        scope.noData = false;
                    } else {
                        scope.noData = true;
                        return;
                    }

                    angular.forEach(newVal, function (item, idx) {
                        if (angular.isUndefined(item.labelColor)) {
                            item.labelColor = labelColors[idx % labelColors.length];
                        }

                        // Set colour
                        if (angular.isDefined(item.AdditionalData) && angular.isDefined(item.AdditionalData.value) && item.AdditionalData.value.length > 0 && item.AdditionalData.value[0].indexOf('#') === 0 && item.AdditionalData.value[0].length === 7) {
                            item.Color = item.AdditionalData.value[0];
                        }
                    });

                    if (angular.isDefined(scope.colors)) {
                        colors = scope.colors.split(',');
                    }
                    render();
                    // Commented as re render required to update colors
                    // if (chart === undefined) {
                    // render();
                    // }

                    chart.dataProvider = newVal;
                    chart.validateData();
                }
            });

            function render() {

                if (window.screen.width < 500) {
                    legendPosition = "bottom";
                    legendAlign = 'center';
                }

                var innerRadius = "0%";
                if (angular.isDefined(scope.innerRadius)) {
                    innerRadius = scope.innerRadius.replace(/%$/, '') + '%';
                }

                var config = {
                    "addClassNames": true,
                    "type": "pie",
                    "colors": colors,
                    "colorField": "Color",
                    "balloonText": "<b>Reach:</b> [[reach]]<br><b>Average Time:</b> [[time]]",
                    "innerRadius": innerRadius,
                    "labelText": "[[Category]]",
                    "fontSize": 12,
                    "radius": "32%",
                    "titleField": "Category",
                    "valueField": valueField(scope.chartData[0]),
                    "dataProvider": scope.chartData,
                    "pullOutRadius": "0",
                    "percentPrecision": precision,
                    "startDuration": 0,
                    "legend": {
                        enabled: false,
                        align: legendAlign,
                        position: legendPosition,
                        valueText: '',
                        switchable: SETTINGS.CHARTS.LEGEND.SWITCHABLE,
                        color: legendColor
                    }
                };

                if (angular.isDefined(scope.text)) {
                    config.allLabels = [
                        {
                            "align": "center",
                            "bold": true,
                            "size": 30,
                            "text": scope.text,
                            "y": "38%"
                        }
                    ];
                }

                if (angular.isDefined(scope.legendLabelWidth)) {
                    config.legend['labelWidth'] = scope.legendLabelWidth;
                }

                chart = AmCharts.makeChart(scope.id + "_chart", config, 100);

                function exportChart() {

                    var exportConfig = {};

                    var hiddenDiv = angular.element(document.getElementById(hiddenID));
                    hiddenDiv.css({
                        width: exportW + 'px',
                        height: exportH + 'px'
                    });

                    // Copy visible chart config
                    angular.copy(config, exportConfig);

                    exportConfig.startDuration = 0;
                    exportConfig.autoMargins = false;
                    exportConfig.marginLeft = 100;
                    exportConfig.marginRight = 100;
                    exportConfig.marginTop = 50;
                    exportConfig.marginBottom = 80;
                    exportConfig.labelText = "[[Category]]\nReach: [[reach]]\nAvg Time: [[time]]";

                    // Update data
                    exportConfig.dataProvider = scope.chartData;

                    exportConfig.legend.autoMargins = false;
                    exportConfig.legend.marginRight = 50;
                    exportConfig.legend.color = '#333333';

                    if (angular.isDefined(scope.title)) {
                        exportConfig.marginTop += 50;
                    }

                    if (angular.isDefined(scope.subtitle)) {
                        exportConfig.marginTop += 30;
                    }

                    if (angular.isDefined(scope.footer)) {
                        exportConfig.marginBottom += 50;
                    }

                    exportConfig.export = {
                        enabled: true,
                        libs: {
                            autoLoad: false
                        },
                        menu: [],
                        afterCapture: function () {
                            var instance = this;

                            // Header rect
                            var headerRect = new fabric.Rect({
                                top: 10,
                                left: 0,
                                width: exportW,
                                height: 5,
                                fill: '#e4e8eb'
                            });
                            instance.setup.fabric.add(headerRect);

                            // Logo
                            var imgEl = document.querySelector('#chart-header-img');
                            if (imgEl !== null) {
                                var logo = new fabric.Image(imgEl, {
                                    left: exportW - imgEl.width - 40,
                                    top: 15
                                });
                                instance.setup.fabric.add(logo);
                            }

                            var xPos = 30, yPos = 35;

                            // Export label
                            if (angular.isDefined(scope.exportLabel)) {
                                var label = new fabric.Text(scope.exportLabel, {
                                    left: xPos,
                                    top: yPos,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 18,
                                    fontWeight: 700
                                });
                                instance.setup.fabric.add(label);
                                yPos += 20;
                            }

                            // Title
                            if (angular.isDefined(scope.chartTitle)) {
                                var title = new fabric.Text(scope.chartTitle.toUpperCase(), {
                                    left: xPos,
                                    top: 40,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 18
                                });
                                title.left = 30;
                                instance.setup.fabric.add(title);
                            }

                            // Subtitle
                            if (angular.isDefined(scope.subtitle)) {
                                var subtitle = new fabric.Text(scope.subtitle, {
                                    left: xPos,
                                    top: yPos,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 15
                                });
                                subtitle.left = exportW / 2 - subtitle.width / 2;
                                instance.setup.fabric.add(subtitle);
                            }

                            // Source
                            if (angular.isDefined(scope.source)) {
                                // Source
                                var src = new fabric.Textbox('Source: ' + scope.source, {
                                    width: exportW - (2 * 30),
                                    fontSize: 10,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    textAlign: 'left',
                                    height: 50,
                                    left: xPos,
                                    top: exportH - 50
                                });
                                instance.setup.fabric.add(src);
                            }

                            // Footer
                            if (scope.footer) {
                                var footer = new fabric.Text(scope.footer, {
                                    left: xPos,
                                    top: exportH - 50,
                                    fontFamily: SETTINGS.FONT_FAMILY,
                                    fontSize: 10
                                });
                                instance.setup.fabric.add(footer);
                            }

                            // Copyright text
                            var footerText = new fabric.Text('Copyright © 2018 The Nielsen Company', {
                                left: xPos,
                                top: exportH - 38,
                                fontFamily: SETTINGS.FONT_FAMILY,
                                fontSize: 10
                            });
                            instance.setup.fabric.add(footerText);

                            // Footer rect
                            var footerRect = new fabric.Rect({
                                top: exportH - 15,
                                left: 0,
                                width: exportW,
                                height: 5,
                                fill: '#e4e8eb'
                            });
                            instance.setup.fabric.add(footerRect);

                        }
                    };

                    hiddenChart = AmCharts.makeChart(hiddenID, exportConfig);

                    hiddenChart.export.capture({}, function () {
                        this.toPNG({multiplier: 2}, function (data) {
                            this.download(data, this.defaults.formats.PNG.mimeType, scope.chartTitle + '.png');
                        });
                    });
                }

                scope.exportChart = exportChart;

                function downloadData() {
                    if (angular.isDefined(scope.chartDataKey)) {
                        DataFactory.download(scope.chartDataKey, scope.chartTitle);
                    }
                }

                scope.downloadData = downloadData;
            }

            function valueField(point) {
                var vF;
                angular.forEach(point, function (field, key) {
                    if (key == 'Category' || vF != undefined) {
                        return;
                    }

                    // Get the first field which is not Category
                    vF = key;
                });
                return vF;
            }
        }
    }
})();
